import { merge } from 'lodash';
import { ActividadBase } from './actividad.model';
import { TareaEstado, TareaTipo } from './tarea.model';
import { TramiteBase } from './tramite.model';
import { Categoria } from './categoria.model';
import { Static } from '../util/static';

/**
 * Tipos de procesos en el sistema
 */
export type TypeProcess = 'process' | 'secondary_process';
/**
 * Acciones para la administracion de procesos
 */
export type CategoryAction = 'category' | 'process' | 'tramite' | 'secondaryProcess' | 'genericT';

/**
 * Clase base con propiedades estándar para construir
 * otras clases de este archivo.
 *
 * @export
 * @class ProcesoBase
 */
export class ProcesoBase {
  id: number;
  nombre: string;
  descripcion: string;
}

/**
 * Procesos asociados a los trámites.
 *
 * @export
 * @class Proceso
 */
export class Proceso extends ProcesoBase {
  proceso_categoria: number;
}

/**
 * Proceso filtrado de a través de la categoria.
 *
 * Los endpoints que satisface son: processCategory.
 *
 * @export
 * @class ProcesoCategoria
 * @extends {ProcesoBase}
 */
export class ProcesoCategoria extends ProcesoBase {
  procesos: ProcesoBase[];
}

/**
 * Modelo de la consuta de los procesos secundarios
 *
 * @export
 * @class ProcesoSecundario
 * @extends {ProcesoBase}
 */
export class ProcesoSecundario extends ProcesoBase {
  roles: RolesProcesoSecundario[];
  etapas: EtapasProcesoSecundario[];
  estado_expediente_inicia: EstadoExpedienteIniciaSecundaria;
  finalizaciones: FinalizacionSecundaria[];
}

/**
 * Modelo complementario de los roles que pueden interactuar con el proceso secundario
 *
 * @export
 * @class RolesProcesoSecundario
 */
export class RolesProcesoSecundario {
  id_rol: number;
  nombre: string;
}

/**
 * Modelo complementario de las etapas del tramite que pueden interactuar con el proceso secundario
 *
 * @export
 * @class EtapasProcesoSecundario
 */
export class EtapasProcesoSecundario {
  id_etapa_tramite?: number;
  id_estado_expediente?: number;
  nombre: string;
}

/**
 * Modelo de consulta las finalizaciones de las secundarias
 *
 * @export
 * @class FinalizacionSecundaria
 */
export class FinalizacionSecundaria {
  id?: number;
  parametros: any;
  tarea_inicio: TareaInicioFinalizacionSecundaria;
  tarea_destino: TareaDestinoFinalizacionSecundaria;
  tipo_finalizacion: TipoFinalizacionSecundaria;
}

/**
 * Modelo complementario de finalizaciones para guardar o modificar secundarias
 *
 * @export
 * @class SecundariaFinalizacion
 */
export class SecundariaFinalizacion {
  tarea_inicio: number;
  tarea_destino: number;
  parametros: Partial<{
    finalizacion: boolean;
    enviar_asignacion: boolean;
  }>;
  tipo_finalizacion: number;
  constructor(values: Partial<SecundariaFinalizacion>) {
    Static.setAll(
      this,
      merge(
        {
          parametros: {
            finalizacion: true,
          }
        },
        values
      )
    );
  }
}

/**
 * Modelo de la tarea inicio de una finalizacion de una secundaria
 *
 * @export
 * @class TareaInicioFinalizacionSecundaria
 */
export class TareaInicioFinalizacionSecundaria {
  id: number;
  nombre: string;
  descripcion: string;
  tarea_estado: TareaEstado;
  tarea_tipo: TareaTipo;
  actividad: ActividadBase;
}

/**
 * Modelo de la tarea destino de una finalizacion de una secundaria
 *
 * @export
 * @class TareaDestinoFinalizacionSecundaria
 */
export class TareaDestinoFinalizacionSecundaria {
  id: number;
  nombre: string;
  descripcion: string;
  tarea_estado: TareaEstado;
  tarea_tipo: TareaTipo;
  actividad: ActividadBase;
  tramite: TramiteBase;
  proceso: ProcesoBase;
  categoria: Categoria;
}

/**
 * Modelo del tipo de finalizacion para la secundaria
 *
 * @export
 * @class TipoFinalizacionSecundaria
 * @extends {ProcesoBase}
 */
export class TipoFinalizacionSecundaria extends ProcesoBase { }

/**
 * Modelo de el estado del expediente con el que inicia la secundaria
 *
 * @export
 * @class EstadoExpedienteIniciaSecundaria
 * @extends {ProcesoBase}
 */
export class EstadoExpedienteIniciaSecundaria extends ProcesoBase { }

/**
 * Modelo de los titulos modificados del tramite en la administracion
 *
 * @export
 * @class TituloProceso
 */
export class TituloProceso {
  id: number;
  tipo_titulo: TipoTitulo;
  tramite: number;
  valor: any;
  titulo_texto?: string;
}

/**
 * Modelo de los tipos de titulos del sistema
 *
 * @export
 * @class TipoTitulo
 */
export class TipoTitulo {
  id: number;
  nombre: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/proceso.model.ts